import { render, staticRenderFns } from "./PortalDocuments.vue?vue&type=template&id=7280fe87&scoped=true&"
import script from "./PortalDocuments.vue?vue&type=script&setup=true&lang=js&"
export * from "./PortalDocuments.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./PortalDocuments.vue?vue&type=style&index=0&id=7280fe87&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7280fe87",
  null
  
)

export default component.exports